// AUTO-GENERATED SQL Builder (V40 Final) for Customer
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class CustomerSql {
  private ast = new SqlAst('Customer', 'customer');
  public readonly main: any = {};

  public guid: SqlField;
  public name: SqlField;
  public email: SqlField;
  public phone: SqlField;
  public addressLine: SqlField;
  public userId: SqlField;
  public status: SqlField;
  public icNo: SqlField;
  public marketingConsent: SqlField;
  public photoUrl: SqlField;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public user: SqlNavHybrid;
  public bookingList: SqlNavHybrid;
  public customerAccessLogList: SqlNavHybrid;
  public reviewList: SqlNavHybrid;
  public waitlistList: SqlNavHybrid;
  public weddingCardList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('customer', 'guid', '', 'id', 'customer_guid');
    this.name = new SqlField('customer', 'name', '', 'id', 'customer_name');
    this.email = new SqlField('customer', 'email', '', 'id', 'customer_email');
    this.phone = new SqlField('customer', 'phone', '', 'id', 'customer_phone');
    this.addressLine = new SqlField('customer', 'addressLine', '', 'id', 'customer_addressLine');
    this.userId = new SqlField('customer', 'userId', 'user', 'id', 'customer_user');
    this.status = new SqlField('customer', 'status', '', 'id', 'customer_status');
    this.icNo = new SqlField('customer', 'icNo', '', 'id', 'customer_icNo');
    this.marketingConsent = new SqlField('customer', 'marketingConsent', '', 'id', 'customer_marketingConsent');
    this.photoUrl = new SqlField('customer', 'photoUrl', '', 'id', 'customer_photoUrl');
    this.createdByUser = createNavHybrid('customer', 'customer_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('customer', 'customer_updatedByUser', 'User');
    this.user = createNavHybrid('customer', 'customer_user', 'User');
    this.bookingList = createNavHybrid('customer', 'customer_bookingList', 'Booking');
    this.customerAccessLogList = createNavHybrid('customer', 'customer_customerAccessLogList', 'CustomerAccessLog');
    this.reviewList = createNavHybrid('customer', 'customer_reviewList', 'Review');
    this.waitlistList = createNavHybrid('customer', 'customer_waitlistList', 'Waitlist');
    this.weddingCardList = createNavHybrid('customer', 'customer_weddingCardList', 'WeddingCard');
    this.id = new SqlField('customer', 'id', '', 'id', 'customer_id');
    this.isDeleted = new SqlField('customer', 'isDeleted', '', 'id', 'customer_isDeleted');
    this.createdBy = new SqlField('customer', 'createdBy', '', 'id', 'customer_createdBy');
    this.createdDate = new SqlField('customer', 'createdDate', '', 'id', 'customer_createdDate');
    this.updatedBy = new SqlField('customer', 'updatedBy', '', 'id', 'customer_updatedBy');
    this.updatedDate = new SqlField('customer', 'updatedDate', '', 'id', 'customer_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:CustomerSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:CustomerSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:CustomerSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:CustomerSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:CustomerSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:CustomerSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:CustomerSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:CustomerSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:CustomerSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:CustomerSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
